module.exports = __webpack_public_path__ + "img/bg3.391eb6c6.png";